import { GALAXY_THEME_STORAGE_KEY } from "@gx/dls/theme/constants";

export enum LocalStorageKey {
  THEME = "THEME",
  PROJECTS_VIEW = "PROJECTS_VIEW",
  SOURCES_VIEW = "SOURCES_VIEW",
}

const LOCAL_STORAGE_KEY_MAP = {
  [LocalStorageKey.THEME]: GALAXY_THEME_STORAGE_KEY,
  [LocalStorageKey.PROJECTS_VIEW]: "galaxy:projects:view",
  [LocalStorageKey.SOURCES_VIEW]: "galaxy:sources:view",
} as const satisfies Record<LocalStorageKey, string>;

export const getLocalStorageKey = (key: LocalStorageKey) => LOCAL_STORAGE_KEY_MAP[key];
